import type { Object3D, Mesh } from "three"

export default function isMesh(object?: Object3D): object is Mesh {
  return (object as Mesh)?.isMesh
}